import React from "react"
import { Navigate } from "react-router-dom"
import { useAppSelector } from "../redux/hooks"

interface Props {
  children: React.ReactNode
}
const PublicRoute: React.FC<Props> = ({ children }) => {
  const { token } = useAppSelector((state) => state.auth)

  if (token) {
    return <Navigate to="/" replace />
  }
  return <>{children}</>
}

export default PublicRoute
